<template>
    <v-form ref="form">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.score.update') }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="mt-6">
                        <v-col cols="12">
                            <v-text-field
                                :rules="numRules"
                                :label="$vuetify.lang.t('$vuetify.custom.score.currScore')+'*'"
                                v-model="scoreMsg.score"
                            ></v-text-field>
                        </v-col>
<!--                        <v-col cols="12">-->
<!--                            <v-text-field-->
<!--                                :rules=numRules-->
<!--                                :label="$vuetify.lang.t('$vuetify.custom.score.currRank')+'*'"-->
<!--                                v-model="scoreMsg.rank"-->
<!--                            ></v-text-field>-->
<!--                        </v-col>-->
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" dark @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}
                </v-btn>
                <v-btn color="success" dark @click="addUser">{{ $vuetify.lang.t('$vuetify.custom.class.update') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<style></style>
<script>

    export default {
        name: 'score-update',
        model: {
            prop: 'dialog',
            event: 'parent-event'
        },
        props: {
            dialog: Boolean,
            scoreMsg:Object
        },
        data: () => ({
            rules: {
                required: value => !!value || '请输入'
            },
            numRules:[
                v => !!v || '必填',
                v => /^([1-9]\d?|100)$/.test(v) || '1-100之内',
            ],
        }),
        methods: {
            hiddenDialog() {
                this.$emit('initialize')
                this.$emit('parent-event', false);
            },
            addUser() {
                if (this.$refs.form.validate()) {
                    this.$api.achievement.updateAchievement(this.scoreMsg).then(data => {
                      if (data.flag) {
                        this.$dialog.alert("修改成功");
                        this.$emit('initialize')
                        this.hiddenDialog();
                      }else{
                        this.$dialog.alert(data.msg)
                      }
                    })

                }
            }
        },
        components: {
        },
    }
</script>
